<template>
  <div class="page-404">
    <div class="container" :class="{active: show}">
      <span>404</span>
      <h1>Page Not Found</h1>
      <router-link to="/">Back to home</router-link>
    </div>
  </div>
</template>

<script>
import { useShowTimeout } from '../compositions/useShowTimeout'

export default {
  name: 'NotFound',
  head: {
    title() {
      return {
        inner: 'Not Found'
      }
    },
  },
  setup() {
    const show = useShowTimeout(1000)

    return {
      show
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    @extend %container;
  
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }

  span {
    @extend %font-regular;
    line-height: 0.4rem;
    font-size: 0.4rem;
    letter-spacing: 0.5rem;
    transition: opacity 0.8s $ease-out, letter-spacing 1s $ease-out;
    opacity: 0;

    .active & {
      opacity: 1;
      letter-spacing: 0.2rem;
    }
  }

  h1 {
    @extend %font-bold;

    font-size: 3rem;
    line-height: 4rem;
    opacity: 0;
    color: $red;
      
    letter-spacing: 0.5rem;
    transition: opacity 0.8s 1.4s $ease-out, letter-spacing 1s 1.4s $ease-out;

    .active & {
      opacity: 1;
      letter-spacing: 0;
    }
  }

  span, a {
    @extend %font-regular;

    font-size: 0.6rem;
    letter-spacing: 0.7rem;
    opacity: 0;
    color: $black;

    .active & {
      opacity: 1;
      letter-spacing: 0.2rem;
    }
  }

  span {
    transition: opacity 0.8s 1s $ease-out, letter-spacing 1s 1s $ease-out;
  }

  a {
    transition: opacity 0.8s 1.8s $ease-out, letter-spacing 1s 1.8s $ease-out;
  }
</style>